import React, {Component} from 'react';
import DevicesContext from "./DevicesContext";
import axios from "axios";
import {host} from "../utils/constants";

class DevicesProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.token = this.props.token;
    }

    fetch(serial) {
        if (this.state[serial]) {
            return;
        }

        this.loadDeviceFromCache(serial);

        axios.get(`${host}/public/devices/${serial}`, {
            headers: {
                'Authorization': `Bearer ${this.token}`
            },
        }).then(this.handleDevice.bind(this, serial));
    }

    loadDeviceFromCache(serial) {
        const json = window.localStorage.getItem(`device_${serial}`);
        if (!json) {
            return;
        }

        const data = JSON.parse(json);
        this.setDeviceState(serial, data);
    }

    handleDevice(serial, {data}) {
        window.localStorage.setItem(`device_${serial}`, JSON.stringify(data));
        this.setDeviceState(serial, data);
    }

    setDeviceState(serial, data) {
        this.setState({
            [serial]: {
                ...data,
            }
        })
    }


    render() {
        return (
            <DevicesContext.Provider value={{
                fetch: this.fetch.bind(this),
                state: this.state
            }}>
                {this.props.children}
            </DevicesContext.Provider>
        );
    }
}

DevicesProvider.propTypes = {};

export default DevicesProvider;
